export const MESSAGE_TYPES = {
  error: 'error',
  info: 'info',
  success: 'success'
};

export const GLOBAL_MESSAGE_TYPE_LIST_MAP = {
  error: 'danger',
  info: 'info',
  success: 'success'
};

export const ERROR_CONTENT_TYPE = 'application/problem+json';

export const NOT_FOUND_MSG_TYPE = 'SOMETHING_WENT_WRONG';
export const NOTIFICATION_MESSAGES = 'NOTIFICATIONS_MESSAGES';

